/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Card, Image } from 'semantic-ui-react';
import CredibilityIcon from 'assets/images/credibility.svg';
import currencyFormat from 'utils/currencyFormat';
import { capitalizeEachWords } from 'utils/capitalize';

const hrStyle = {
  width: '100%',
  height: '1px',
  marginTop: '5px',
  marginBottom: '5px',
  backgroundColor: '#EBEBEB',
  border: 'none',
  color: '#EBEBEB',
};

const rowStyle = {
  marginTop: '12px',
  marginBottom: '12px',
};

const getCreditScoreColor = creditScore => {
  if (creditScore >= 300 && creditScore <= 559) {
    return '#DB2829';
  }
  if (creditScore >= 560 && creditScore <= 649) {
    return '#FF5630';
  }
  if (creditScore >= 650 && creditScore <= 699) {
    return '#D77501';
  }
  if (creditScore >= 700 && creditScore <= 749) {
    return '#00E485';
  }
  if (creditScore >= 750 && creditScore <= 850) {
    return '#029357';
  }
  return 'grey';
};

const GroupSaveScoreInfo = ({ data }) => {
  return (
    <Card className="">
      <Card.Content>
        <Grid className="">
          <Grid.Column width="16">
            <Grid.Row columns="1" style={rowStyle}>
              <Grid>
                <Grid.Column
                  columns="8"
                  style={{
                    width: '50%',
                  }}
                >
                  Group Save Score
                </Grid.Column>
                <Grid.Column
                  columns="8"
                  style={{
                    width: '50%',
                  }}
                >
                  <div
                    className="flex flex-center-vertical"
                    style={{
                      justifyContent: 'end',
                      alignItems: 'center',
                      height: '100%',
                    }}
                  >
                    <Image
                      src={CredibilityIcon}
                      style={{
                        margin: 0,
                      }}
                    />
                    <span
                      style={{
                        color: getCreditScoreColor(
                          data?.group?.loan_score,
                        ),
                        fontWeight: 'bolder',

                        fontSize: '25px',
                        letterSpacing: '0.75px',
                        marginLeft: '5px',
                      }}
                    >
                      {data?.group?.loan_score}
                    </span>
                  </div>
                </Grid.Column>
              </Grid>
            </Grid.Row>
            <hr className="" style={hrStyle} />
            <Grid.Row columns="1" style={rowStyle}>
              <Grid>
                <Grid.Column
                  columns="8"
                  style={{
                    width: '50%',
                  }}
                >
                  Risk Rating
                </Grid.Column>
                <Grid.Column
                  columns="8"
                  style={{
                    width: '50%',
                  }}
                >
                  <div
                    className="flex flex-center-vertical"
                    style={{
                      justifyContent: 'end',
                      alignItems: 'center',
                      height: '100%',
                    }}
                  >
                    {/* <Image
                      src={RatingIcon}
                      style={{
                        margin: 0,
                      }}
                    /> */}
                    <span
                      style={{
                        fontWeight: 'bolder',

                        fontSize: '16px',
                        letterSpacing: '0.75px',
                        marginLeft: '5px',
                      }}
                    >
                      {capitalizeEachWords(
                        data?.group?.loan_risk_level,
                      )}
                    </span>
                  </div>
                </Grid.Column>
              </Grid>
            </Grid.Row>
            <hr className="" style={hrStyle} />
            <Grid.Row columns="1" style={rowStyle}>
              <Grid>
                <Grid.Column
                  columns="8"
                  style={{
                    width: '50%',
                  }}
                >
                  Previous Cycle Total Savings
                </Grid.Column>
                <Grid.Column
                  columns="8"
                  style={{
                    width: '50%',
                  }}
                >
                  <div
                    className="flex flex-center-vertical"
                    style={{
                      justifyContent: 'end',
                      alignItems: 'center',
                      height: '100%',
                    }}
                  >
                    <span
                      style={{
                        fontWeight: 'bold',
                        textAlign: 'right',
                        fontSize: '18px',
                        letterSpacing: '0.75px',
                        marginLeft: '5px',
                      }}
                    >
                      {currencyFormat(
                        data?.group?.loan_score_metadata
                          ?.prev_cycle_total_savings,
                      )}
                    </span>
                  </div>
                </Grid.Column>
              </Grid>
            </Grid.Row>
            <hr className="" style={hrStyle} />
            <Grid.Row columns="1" style={rowStyle}>
              <Grid>
                <Grid.Column
                  columns="8"
                  style={{
                    width: '50%',
                  }}
                >
                  Previous Cycle Growth Rate
                </Grid.Column>
                <Grid.Column
                  columns="8"
                  style={{
                    width: '50%',
                  }}
                >
                  <div
                    className="flex flex-center-vertical"
                    style={{
                      justifyContent: 'end',
                      alignItems: 'center',
                      height: '100%',
                    }}
                  >
                    <span
                      style={{
                        fontWeight: 'bold',
                        textAlign: 'right',
                        fontSize: '18px',
                        letterSpacing: '0.75px',
                        marginLeft: '5px',
                      }}
                    >
                      {
                        data?.group?.loan_score_metadata
                          ?.prev_cycle_growth_rate
                      }
                    </span>
                  </div>
                </Grid.Column>
              </Grid>
            </Grid.Row>
          </Grid.Column>
        </Grid>
      </Card.Content>
    </Card>
  );
};

GroupSaveScoreInfo.propTypes = {
  data: PropTypes.objectOf(Object).isRequired,
};

export default GroupSaveScoreInfo;
